import axios from "axios";

// Set base URL for your backend API
const api = axios.create({
  baseURL: "https://legacy-decor-backend.onrender.com/", //"https://legacy-decor-backend.onrender.com", //"https://legacydecor.in/", //"http://localhost:5000/", // change if deployed
});

// Categories
export const getCategories = async () => {
  const res = await api.get("/categories");
  return res.data;
};

export const getFeaturedCategories = async () => {
  const res = await api.get("/categories/featured");
  return res.data;
};

export const getCategoryById = async (id) => {
  const res = await api.get(`/categories/${id}`);
  return res.data;
};

// Products
export const getProducts = async (
  category,
  skip = 0,
  limit,
  search = "",
  sort = "default",
) => {
  const params = { skip, limit, search };

  if (category) params.category = category;
  if (sort && sort !== "default") {
    params.sort = sort;
  }

  const res = await api.get("/products", { params });
  return res.data;
};

export const getFeaturedProducts = async () => {
  const res = await api.get("/products/featured");
  return res.data;
};

export const getProductById = async (id) => {
  const res = await api.get(`/products/${id}`);
  return res.data;
};

// Add more APIs here as needed (POST, PUT, DELETE)
export const addProduct = async (product) => {
  const res = await api.post("/products", product);
  return res.data;
};

export const updateProductApi = async (id, productData) => {
  const response = await api.put(`/products/${id}`, productData);

  return response.data;
};

export const deleteProductApi = async (id) => {
  const response = await api.delete(`/products/${id}`);

  return response.data;
};

export const addCategory = async (category) => {
  const res = await api.post("/categories", category);
  return res.data;
};

// ------------------- Auth / Registration -------------------

// Email/Password registration
// User Registration
export const registerUser = async (userData) => {
  const res = await api.post("/users/register", userData);
  return res.data;
};

// User Login
export const loginUser = async (loginData) => {
  const res = await api.post("/users/login", loginData);
  return res.data;
};

// Forgot Password

export const forgotPassword = async (email) => {
  const res = await api.post("/users/forgot-password", { email });

  return res.data;
};

// Reset Password

export const resetPassword = async (token, newPassword) => {
  const res = await api.post(`/users/reset-password/${token}`, {
    newPassword,
  });

  return res.data;
};

export const addToCartApi = async (userId, productId, quantity = 1) => {
  const res = await api.post("/cart/add", { userId, productId, quantity });
  return res.data;
};

export const decreaseQtyApi = async (userId, productId) => {
  const res = await api.post("/cart/decrease", { userId, productId });
  return res.data;
};

export const getCartApi = async (userId) => {
  const res = await api.get(`/cart/${userId}`);
  return res.data;
};

export const clearCartApi = async (userId) => {
  return (await api.delete(`/cart/${userId}`)).data;
};

// Remove an item
export const removeFromCartApi = async (userId, productId) => {
  return (await api.delete(`/cart/${userId}/${productId}`)).data;
};

export const updateQuantityApi = async (userId, productId, quantity) => {
  return (await api.put(`/cart/update`, { userId, productId, quantity })).data;
};

export const createOrderApi = async (amount, userId, shipping, cartItems) => {
  const res = await api.post("/payment/create-order", {
    amount,
    userId,
    shipping,
    items: cartItems,
  });
  return res.data;
};

export const updateOrderStatus = async (orderId, order_status) => {
  const res = await api.patch(`/orders/${orderId}/status`, {
    order_status,
  });

  return res.data;
};

export const verifyPaymentApi = async (data) => {
  const res = await api.post("/payment/verify-payment", data);
  return res.data;
};

// Contact / Inquiry
export const sendContactInquiry = async (formData) => {
  const res = await api.post("/contact", formData);
  return res.data;
};

export const changePassword = async ({
  userId,
  currentPassword,
  newPassword,
  token,
}) => {
  const res = await api.post(
    "/users/change-password",
    {
      userId,
      currentPassword,
      newPassword,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return res.data;
};

export const getOrdersApi = async (userId) => {
  const res = await api.get(`/orders/user/${userId}`);

  return res.data;
};

export const getOrderByIdApi = async (orderId) => {
  const res = await api.get(`/orders/${orderId}`);

  return res.data;
};

export const getAllOrdersApi = async () => {
  const response = await api.get("/orders/all");
  return response.data;
};

export const createReturnRequestApi = async (formData) => {
  const res = await api.post("/returns", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};

// =====================================================
// APPROVE RETURN REQUEST
// =====================================================

export const approveReturnRequest = async (returnId, adminNote = "") => {
  const response = await api.patch(`/returns/${returnId}/approve`, {
    adminNote,
  });

  return response.data;
};

// =====================================================
// DECLINE RETURN REQUEST
// =====================================================

export const declineReturnRequest = async (returnId, adminNote) => {
  const response = await api.patch(`/returns/${returnId}/decline`, {
    adminNote,
  });

  return response.data;
};

export const getUserReturnRequestsApi = async (userId) => {
  const response = await api.get(`/returns/user/${userId}`);
  return response.data;
};

export const requestRestockApi = async (data) => {
  const response = await api.post("/products/restock-request", data);
  return response.data;
};

export default api;
